import { Button } from '@bambi/component-library/src/components/Button/Button';

import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';
import type { RootState } from 'src/app/store/types';
import type {
  PassengerRead,
  PayerOrganizationRead,
} from 'src/common/external/bambi-api/bambiApi';
import { PassengerInfoFormSection } from 'src/features/add-trip/PassengerInfoFormSection';

import { PassengerFormDialog } from '../passenger/PassengerForm/PassengerFormDialog';
import { addATrip } from './addATrip.slice';
import { AddATripFlowDialog } from './AddATripFlowDialog';
import { AddATripFlowForm } from './AddATripFlowForm';
import { PricingFormSection } from './Pricing';
import { ServiceDetailsFormSection } from './ServiceDetails';
import { TripBookedBySection } from './TripBookedBySection';
import { TripDetailsFormSection } from './TripDetails';
import { TripPayerInactiveWarning } from './TripPayerInactiveWarning';

export function AddATripFlow() {
  const dispatch = useAppDispatch();
  const passenger: PassengerRead | null | undefined = useAppSelector(
    (state: RootState) => state.addATrip.selectedPassenger
  );

  const selectedPayer = useAppSelector(
    (state: RootState) => state.addATrip.selectedPayer
  );

  const isEditingPassenger = useAppSelector(
    (state: RootState) => state.addATrip.isEditingPassenger
  );

  const onPassengerSelected = (passenger: PassengerRead | undefined) => {
    dispatch(addATrip.actions.selectPassenger(passenger));
  };

  const onPassengerEdit = (passenger: PassengerRead) => {
    // TODO: Need to move passenger crud to be more global to get around this dumb hack.
    // This supports the following use case:
    // 1. Click edit passenger after selecting one
    // 2. Click cancel (causing the form state to reset)
    // 3. Click edit again for whatever reason
    // Wanted to keep changes to the passenger form editing as small as possible
    const temp = { ...passenger };
    dispatch(addATrip.actions.selectNoPassenger());
    dispatch(addATrip.actions.selectPassenger(temp));
    dispatch(addATrip.actions.setIsEditingPassenger(true));
  };

  const onPayerSelected = (payer: PayerOrganizationRead | null) => {
    dispatch(addATrip.actions.selectPayer(payer));
  };

  return (
    <>
      <Button
        variant="primary-outline"
        onClick={() => dispatch(addATrip.actions.open())}
      >
        Add Trip
      </Button>
      <AddATripFlowDialog>
        <AddATripFlowForm>
          {selectedPayer && !selectedPayer.is_active && (
            <TripPayerInactiveWarning />
          )}
          <PassengerInfoFormSection
            selectedPassenger={passenger}
            onPassengerSelected={onPassengerSelected}
            onPassengerEdit={onPassengerEdit}
          />
          <PricingFormSection
            onPayerSelected={onPayerSelected}
            selectedPayer={selectedPayer}
          />
          <ServiceDetailsFormSection />
          <TripBookedBySection selectedPayer={selectedPayer} />
          <TripDetailsFormSection />
        </AddATripFlowForm>
      </AddATripFlowDialog>
      <PassengerFormDialog
        open={isEditingPassenger}
        setOpen={(open) => {
          dispatch(addATrip.actions.setIsEditingPassenger(open));
        }}
        passenger={passenger || undefined}
      />
    </>
  );
}
